export const delay = (ms: number | undefined) => new Promise(res => setTimeout(res, ms));

export const fetch_retry = async (url: string, retry = 4) => {
    while (true) {
        const response = await fetch(url);
        if (response.ok)
            return await response.json();

        if (--retry == 0)
            throw new Error("Unable to fetch settings");

        await delay(500);
    }
}
